export const distinct = (array: Array<any>) => {
	return Array.from(new Set(array));
};
